import { useEffect, useState } from 'react';
import {
  getApiReadySnapshot,
  subscribeApiReady,
  type ApiReadySnapshot,
} from '../api/apiClient';

/** Subscribe to ACA cold-start /api/health wake state (shared with apiClient). */
export function useApiReady(): ApiReadySnapshot {
  const [snapshot, setSnapshot] = useState<ApiReadySnapshot>(getApiReadySnapshot);

  useEffect(() => subscribeApiReady(setSnapshot), []);

  return snapshot;
}
